import React, { useState,useEffect } from 'react';
import { uid } from 'uid';
import InvoiceItem from './invoiceItem';
import InvoiceModal from './invoiceModal';
import incrementString from '../../helpers/incrementString';
import Label from '../Label';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';

const date = new Date();
const irishDate = date.toLocaleDateString('en-IE', {
  year: 'numeric',
  month: 'long', // Use 'long' to get the full month name
  day: 'numeric' // Use 'numeric' to get the day without leading zeros
});

const InvoiceForm = () => {
  const token = localStorage.getItem('token');
  const decodedToken = jwtDecode(token);
  const userId ={userID: decodedToken.id};

  const [isOpen, setIsOpen] = useState(false);
  const [discount, setDiscount] = useState('');
  const [tax, setTax] = useState('');
  const [invoiceNumber, setInvoiceNumber] = useState(1);
  const [cashierName, setCashierName] = useState('');
  const [customerId, setCustomerId] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');
  const [address3, setAddress3] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [items, setItems] = useState([
    {
      id: uid(6),
      name: '',
      qty: 1,
      price: '1.00',
    },
  ]);

  const [businessName, setBusinessName] = useState('Irish Cellular Communications Ltd');
  const [senderAddress, setSenderAddress] = useState('25 Nordic Enterprise Park');
  const [senderCity, setSenderCity] = useState('Kncokgriffin');
  const [senderState, setSenderSate] = useState('Kinsale');
  const [senderState1, setSenderSate1] = useState('Co. Cork');
  const [senderPhone, setSenderPhone] = useState('+353 (0)86 251 3288');
  const [senderPostalCode, setSenderPostalCode] = useState('P17 EY49');
  //----------fetch customer information------------------
  const [productList, setProductList] = useState([]);
  const fetchProduct = async() => {
      try {
          const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

          if (!POCBaseUrl) {
              throw new Error('API base URL is not defined');
          }
          const response = await axios.post(`${POCBaseUrl}/products/get`,
              {
                  headers: {
                    "Content-Type": "application/json", // Specify content type
                    Authorization: `Bearer ${token}`, // Include the token
                  },
                }
          )
          .then(response=>{
              setProductList(response.data.data);
          })
          .catch(error=>{
              console.error("There was an error", error);
          })
      } catch (error) {
          console.error('Error sending message:', error);
      }
  }

  const [customerList, setCustomerList] = useState([]);
  const fetchCustomer = async() => {
      try {
          const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

          if (!POCBaseUrl) {
              throw new Error('API base URL is not defined');
          }
          const response = await axios.post(`${POCBaseUrl}/debtors/getcustomer`,
              {
                  headers: {
                    "Content-Type": "application/json", // Specify content type
                    Authorization: `Bearer ${token}`, // Include the token
                  },
                }
          )
          .then(response=>{
              setCustomerList(response.data.data);
          })
          .catch(error=>{
              console.error("There was an error", error);
          })
      } catch (error) {
          console.error('Error sending message:', error);
      }
  }

  const fetchInvoiceNumber = async() => {
    try {
        const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

        if (!POCBaseUrl) {
            throw new Error('API base URL is not defined');
        }
        const response = await axios.post(`${POCBaseUrl}/invoices/getinvoicenumber`,
            {
                headers: {
                  "Content-Type": "application/json", // Specify content type
                  Authorization: `Bearer ${token}`, // Include the token
                },
              }
        )
        .then(response=>{
            setInvoiceNumber(response.data.data);
        })
        .catch(error=>{
            console.error("There was an error", error);
        })
    } catch (error) {
        console.error('Error sending message:', error);
    }
  }

  useEffect(()=> {
      fetchCustomer();
      fetchProduct();
      fetchInvoiceNumber();
  },[])

  const handleCustomer = (e) => {
    const value = e.target.value;
    setCustomerId(value);

    const customerData = customerList.filter((customer) => customer._id === value);
    console.log('value',value,customerData);
    setCustomerName(customerData[0].name);
    setAddress1(customerData[0].address1);
    setAddress2(customerData[0].address2);
    setAddress3(customerData[0].address3);
    setPostalCode(customerData[0].postal_code);
  }
//----------------------------------------------------------
  const reviewInvoiceHandler = (event) => {
    event.preventDefault();
    setIsOpen(true);
  };

  // const addNextInvoiceHandler = () => {
  //   setInvoiceNumber((prevNumber) => incrementString(prevNumber));
  //   setItems([
  //     {
  //       id: uid(6),
  //       name: '',
  //       qty: 1,
  //       price: '1.00',
  //     },
  //   ]);
  // };

  const addItemHandler = () => {
    const id = uid(6);
    setItems((prevItem) => [
      ...prevItem,
      {
        id: id,
        name: '',
        qty: 1,
        price: '1.00',
      },
    ]);
  };

  const deleteItemHandler = (id) => {
    setItems((prevItem) => prevItem.filter((item) => item.id !== id));
  };

  const edtiItemHandler = (event) => {
    const editedItem = {
      id: event.target.id,
      name: event.target.name,
      value: event.target.value,
    };

    const newItems = items.map((items) => {
      for (const key in items) {
        if (key === editedItem.name && items.id === editedItem.id) {
          items[key] = editedItem.value;
        }
      }
      return items;
    });

    setItems(newItems);
  };

  const subtotal = items.reduce((prev, curr) => {
    if (curr.name.trim().length > 0)
      return prev + Number(curr.price * Math.floor(curr.qty));
    else return prev;
  }, 0);
  const taxRate = (tax * subtotal) / 100;
  const discountRate = (discount * subtotal) / 100;
  const total = subtotal - discountRate + taxRate;

  const handleDataFromChild = (data) => {
    setDiscount(data);
  };

  return (
    <form
      className="relative flex flex-col px-2 md:flex-row"
      onSubmit={reviewInvoiceHandler}
    >
      <div className="my-6 flex-1 space-y-2  rounded-md bg-white p-4 shadow-sm sm:space-y-4 md:p-6">
        <div className="flex flex-col justify-between space-y-2 border-b border-gray-900/10 pb-4 md:flex-row md:items-center md:space-y-0">
          <div className="flex space-x-2">
            <span className="font-bold">Current Date: </span>
            <span>{irishDate}</span>
          </div>
          <div className="flex items-center space-x-2">
            <label className="font-bold" htmlFor="invoiceNumber">
              Invoice Number:
            </label>
            <input
              required
              className="max-w-[130px] bg-gray-100 border border-[#dcdfe6] rounded box-border inline-block h-[35px] leading-[35px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
              type="number"
              name="invoiceNumber"
              id="invoiceNumber"
              min="1"
              step="1"
              disabled
              value={String(invoiceNumber).padStart(6, '0')}
              onChange={(event) => setInvoiceNumber(event.target.value)}
            />
          </div>
        </div>
        <h1 className="text-center text-lg font-bold">INVOICE</h1>
        {/* ------------------------------owner------------------------------ */}
        <div className='flex'>
          <div className='flex justify-center'>
            <div className='w-[450px]'>
              <div className='border-b border-[#dedfe1] font-bold w-[90%]'>Sender Information</div>
              <div className='flex flex-row items-center m-[20px] !mt-[5px] !mb-[5px] pt-3'>
                  <span className='w-[120px] text-[black] text-[14px] font-bold'>Business Name :</span>
                  <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                      <input
                          type="text"
                          autoComplete="off"
                          name='businessName'
                          value={businessName}
                          placeholder={'Input the Business Name'}
                          onChange={(event) => setBusinessName(event.target.value)}
                          className="w-[250px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[35px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
                          required
                      />
                  </div>
              </div>
              {/* <div className='flex flex-row items-center m-[20px] !mt-[5px] !mb-[5px] pt-1'>
                  <span className='w-[120px] text-[black] text-[14px] font-bold'>Adress :</span>
                  <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                      <input
                          type="text"
                          autoComplete="off"
                          name='senderAddress'
                          value={senderAddress}
                          placeholder={'Input the Sender Address'}
                          onChange={(event) => setSenderAddress(event.target.value)}
                          className="w-[250px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[35px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
                          required
                      />
                  </div>
              </div>
              <div className='flex flex-row items-center m-[20px] !mt-[5px] !mb-[5px] pt-1'>
                  <span className='w-[120px] text-[black] text-[14px] font-bold'>City :</span>
                  <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                      <input
                          type="text"
                          autoComplete="off"
                          name='senderCity'
                          value={senderCity}
                          placeholder={'Input the City'}
                          onChange={(event) => setSenderCity(event.target.value)}
                          className="w-[250px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[35px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
                          required
                      />
                  </div>
              </div> */}
              <div className='flex flex-row items-center m-[20px] !mt-[5px] !mb-[5px] pt-1'>
                  <span className='w-[120px] text-[black] text-[14px] font-bold'>State :</span>
                  <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                      <input
                          type="text"
                          autoComplete="off"
                          name='senderState'
                          value={senderState}
                          placeholder={'Input the State'}
                          onChange={(event) => setSenderSate(event.target.value)}
                          className="w-[250px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[35px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
                          required
                      />
                  </div>
              </div>
              <div className='flex flex-row items-center m-[20px] !mt-[5px] !mb-[5px] pt-1'>
                  <span className='w-[120px] text-[black] text-[14px] font-bold'></span>
                  <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                      <input
                          type="text"
                          autoComplete="off"
                          name='senderState1'
                          value={senderState1}
                          placeholder={'Input the State'}
                          onChange={(event) => setSenderSate1(event.target.value)}
                          className="w-[250px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[35px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
                          required
                      />
                  </div>
              </div>
              <div className='flex flex-row items-center m-[20px] !mt-[5px] !mb-[5px] pt-1'>
                  <span className='w-[120px] text-[black] text-[14px] font-bold'>Phone Number :</span>
                  <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                      <input
                          type="text"
                          autoComplete="off"
                          name='senderPhone'
                          value={senderPhone}
                          placeholder={'Input the Phone Number'}
                          onChange={(event) => setSenderPhone(event.target.value)}
                          className="w-[250px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[35px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
                          required
                      />
                  </div>
              </div>
              <div className='flex flex-row items-center m-[20px] !mt-[5px] !mb-[5px] pt-1'>
                  <span className='w-[120px] text-[black] text-[14px] font-bold'>Postal Code :</span>
                  <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                      <input
                          type="text"
                          autoComplete="off"
                          name='senderPostalCode'
                          value={senderPostalCode}
                          placeholder={'Input the Postal Code'}
                          onChange={(event) => setSenderPostalCode(event.target.value)}
                          className="w-[250px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[35px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
                          required
                      />
                  </div>
              </div>
            </div>
          </div>
          <div className='border-b border-[#dedfe1]'></div>
          {/* ----------------------------customer ------------------------------- */}
          <div className='flex justify-center'>
            <div className='w-[450px]'>
              <div className='items-center border-b border-[#dedfe1] font-bold w-[90%]'>Recipient Information</div>
              <div className='ml-[20px] pt-3 flex'>
                  <Label text={'Company'} className={'!w-[125px]'}/>
                  <div className='relative text-[14px] leading-[40px] !w-[250px]'>
                      <select className='w-[250px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[35px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500'
                          name={'customerId'} value={customerId || ''} onChange={(e) => handleCustomer(e)} placeholder={'Select a Company'}>
                          <option value="" disabled className='text-gray-500'>Select a Company</option>
                          {customerList.map((item) => (
                              <option key={item._id} value={item._id}>
                                  {item.number} - {item.name}
                              </option>
                          ))}
                      </select>
                  </div>
              </div>
              <div className='flex flex-row items-center m-[20px] !mt-[5px] !mb-[5px] pt-1'>
                  <span className='w-[120px] text-[black] text-[14px] font-bold'>Name</span>
                  <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                      <input
                          type="text"
                          autoComplete="off"
                          name='customerName'
                          value={customerName}
                          placeholder={'Input the Customer Name'}
                          onChange={(event) => setCustomerName(event.target.value)}
                          className="w-[250px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[35px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
                          required
                      />
                  </div>
              </div>
              <div className='flex flex-row items-center m-[20px] !mt-[5px] !mb-[5px] pt-1'>
                  <span className='w-[120px] text-[black] text-[14px] font-bold'>Address :</span>
                  <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                      <input
                          type="text"
                          autoComplete="off"
                          name='address1'
                          value={address1}
                          placeholder={'Input the Customer Address'}
                          onChange={(event) => setAddress1(event.target.value)}
                          className="w-[250px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[35px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
                          required
                      />
                  </div>
              </div>
              <div className='flex flex-row items-center m-[20px] !mt-[5px] !mb-[5px] pt-1'>
                  <span className='w-[120px] text-[black] text-[14px] font-bold'>City :</span>
                  <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                      <input
                          type="text"
                          autoComplete="off"
                          name='address3'
                          value={address3}
                          placeholder={'Input the Customer City'}
                          onChange={(event) => setAddress3(event.target.value)}
                          className="w-[250px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[35px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
                          required
                      />
                  </div>
              </div>
              <div className='flex flex-row items-center m-[20px] !mt-[5px] !mb-[5px] pt-1'>
                  <span className='w-[120px] text-[black] text-[14px] font-bold'>State :</span>
                  <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                      <input
                          type="text"
                          autoComplete="off"
                          name='address2'
                          value={address2}
                          placeholder={'Input the Customer State'}
                          onChange={(event) => setAddress2(event.target.value)}
                          className="w-[250px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[35px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
                          required
                      />
                  </div>
              </div>
              <div className='flex flex-row items-center m-[20px] !mt-[5px] !mb-[5px] pt-1'>
                  <span className='w-[120px] text-[black] text-[14px] font-bold'>Postal Code :</span>
                  <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                      <input
                          type="text"
                          autoComplete="off"
                          name='postalCode'
                          value={postalCode}
                          placeholder={'Input the Postal Code'}
                          onChange={(event) => setPostalCode(event.target.value)}
                          className="w-[250px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[35px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
                          required
                      />
                  </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div>
          <label
            htmlFor="customerName"
            className="col-start-2 row-start-1 text-sm font-bold md:text-base"
          >
            City:
          </label>
          <input
            required
            className="flex-1 bg-gray-100 border border-[#dcdfe6] rounded box-border inline-block h-[35px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
            placeholder="Customer name"
            type="text"
            name="customerName"
            id="customerName"
            value={address3}
            onChange={(event) => setCustomerName(event.target.value)}
          />
        </div> */}

        <table className="w-full p-4 text-left">
          <thead>
            <tr className="border-b border-gray-900/10 text-sm md:text-base">
              <th>Description</th>
              <th>QTY</th>
              <th className="text-center">PRICE</th>
              <th className="text-center">ACTION</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <InvoiceItem
                key={item.id}
                id={item.id}
                name={item.name}
                qty={item.qty}
                price={item.price}
                onDeleteItem={deleteItemHandler}
                onEdtiItem={edtiItemHandler}
              />
            ))}
          </tbody>
        </table>
        <button
          className="rounded-md bg-blue-500 px-4 py-2 text-sm text-white shadow-sm hover:bg-blue-600"
          type="button"
          onClick={addItemHandler}
        >
          Add Item
        </button>
        <div className="flex flex-col items-end space-y-2 pt-6">
          <div className="flex w-full justify-between md:w-1/2">
            <span className="font-bold">Subtotal:</span>
            <span>€{subtotal.toFixed(2)}</span>
          </div>
          <div className="flex w-full justify-between md:w-1/2">
            <span className="font-bold">Discount:</span>
            <span>
              ({discount || '0'}%)€{discountRate.toFixed(2)}
            </span>
          </div>
          <div className="flex w-full justify-between md:w-1/2">
            <span className="font-bold">Tax:</span>
            <span>
              ({tax || '0'}%)€{taxRate.toFixed(2)}
            </span>
          </div>
          <div className="flex w-full justify-between border-t border-gray-900/10 pt-2 md:w-1/2">
            <span className="font-bold">Total:</span>
            <span className="font-bold">
              €{total % 1 === 0 ? total : total.toFixed(2)}
            </span>
          </div>
        </div>
      </div>
      <div className="basis-1/4 bg-transparent">
        <div className="sticky top-0 z-10 space-y-4 divide-y divide-gray-900/10 pb-8 md:pt-6 md:pl-4">
          <button
            className="w-full rounded-md bg-blue-500 py-2 text-sm text-white shadow-sm hover:bg-blue-600"
            type="submit"
          >
            Review Invoice
          </button>
          <InvoiceModal
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            invoiceInfo={{
              invoiceNumber,
              cashierName,
              customerId,
              customerName,
              subtotal,
              taxRate,
              tax,
              discountRate,
              total,
              irishDate,
              address1,
              address2,
              address3,
              postalCode,
              businessName,
              senderAddress,
              senderCity,
              senderState,
              senderState1,
              senderPhone,

            }}
            items={items}
            // onAddNextInvoice={addNextInvoiceHandler}
          />
          <div className="space-y-4 py-2">
            <div className="space-y-2">
              <label className="text-sm font-bold md:text-base" htmlFor="tax">
                Tax rate:
              </label>
              <div className="flex items-center">
                <input
                  className="w-full rounded-r-none bg-white shadow-sm bg-[white] border border-[#dcdfe6] rounded box-border h-[35px] leading-[35px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
                  type="number"
                  name="tax"
                  id="tax"
                  min="0.01"
                  step="0.01"
                  placeholder="Input tax"
                  value={tax}
                  onChange={(event) => setTax(event.target.value)}
                />
                <span className="rounded-r-md bg-gray-200 py-2 px-4 text-gray-500 shadow-sm">
                  %
                </span>
              </div>
            </div>
            <div className="space-y-2">
              <label
                className="text-sm font-bold md:text-base"
                htmlFor="discount"
              >
                Discount rate:
              </label>
              <div className="flex items-center">
                <input
                  className="w-full rounded-r-none bg-white shadow-sm bg-[white] border border-[#dcdfe6] rounded box-border h-[35px] leading-[35px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
                  type="number"
                  name="discount"
                  id="discount"
                  min="0"
                  step="0.01"
                  placeholder="Input discount"
                  value={discount}
                  onChange={(event) => setDiscount(event.target.value)}
                />
                {/* <InputSelectBox1 options={[13.35, 23]} type={'number'} name={'discount'} min={'0'} step={'0.01'} placeholder={'0.0'} value={discount} onSendData={handleDataFromChild}/> */}
                <span className="rounded-r-md bg-gray-200 py-2 px-4 text-gray-500 shadow-sm">
                  %
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default InvoiceForm;
